/**
 * Marketplace experiment cohort gate (mirrors backend assessExperimentCohort).
 * @see backend/src/providerOpportunities/service.js
 */

export const EXPERIMENT_START_AT_KEY = "marketplace.experiment.startAt";

/**
 * @param {unknown} response - getSetting / getAllSettings API payload
 * @returns {string}
 */
export const parseSettingStringValue = (response) => {
  const raw =
    response?.data?.value ?? response?.value ?? response?.data ?? response;
  if (raw == null) return "";
  return String(raw).trim();
};

/**
 * @param {Record<string, unknown>|null|undefined} settings
 * @param {Date} [now]
 * @returns {{ open: boolean, reason?: string }}
 */
export const assessExperimentCohort = (settings, now = new Date()) => {
  const startAtRaw = settings?.[EXPERIMENT_START_AT_KEY];
  if (startAtRaw == null || String(startAtRaw).trim() === "") {
    return { open: false, reason: "experiment_not_started" };
  }
  const startAt = new Date(startAtRaw);
  if (Number.isNaN(startAt.getTime())) {
    return { open: false, reason: "experiment_not_started" };
  }
  if (now.getTime() < startAt.getTime()) {
    return { open: false, reason: "experiment_not_started" };
  }
  return { open: true };
};

/**
 * @param {Record<string, unknown>|null|undefined} settings
 * @param {Date} [now]
 * @returns {{ open: boolean, label: string, color: "success"|"warning"|"error" }}
 */
export const getExperimentCohortStatus = (settings, now = new Date()) => {
  const startAtRaw = settings?.[EXPERIMENT_START_AT_KEY];
  const trimmed =
    startAtRaw == null ? "" : String(startAtRaw).trim();

  if (!trimmed) {
    return {
      open: false,
      label: "Cohort closed (startAt not set)",
      color: "error",
    };
  }

  const startAt = new Date(trimmed);
  if (Number.isNaN(startAt.getTime())) {
    return {
      open: false,
      label: "Cohort closed (invalid startAt)",
      color: "error",
    };
  }

  if (now.getTime() < startAt.getTime()) {
    return {
      open: false,
      label: `Cohort closed (opens ${startAt.toISOString()})`,
      color: "warning",
    };
  }

  return {
    open: true,
    label: `Cohort open (since ${startAt.toISOString()})`,
    color: "success",
  };
};
